import React from "react";

export const PageHeader = ({ title, subtitle, actions, testid }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4" data-testid={testid}>
    <div>
      <div className="iso-label">GameEdge · {new Date().toLocaleDateString("en-US", { month: "short", day: "numeric" })}</div>
      <h1 className="font-lexend">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-gray-500 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
